document.addEventListener('click', function(e) {
  const card = e.target.closest('[id^="metric-insight-"] .metric-card');
  if (!card) return;
  
  const section = card.closest('[id^="metric-insight-"]');
  if (!section) return;
  
  const cards = section.querySelectorAll('.metric-card');
  const image = section.querySelector('[id^="metric-insight-image-"]');
  const heading = section.querySelector('.metric-card__why');
  const description = section.querySelector('.metric-card__text');
  
  cards.forEach(c => c.classList.remove('active'));
  card.classList.add('active');
  
  if (image && card.dataset.image) image.src = card.dataset.image;
  if (heading) heading.textContent = card.dataset.heading || '';
  if (description) description.textContent = card.dataset.description || '';
});